import { useFullDomainUrl } from '@/hooks/use-full-domain-url'
import { Button } from '@/shared/ui/button'
import { cn } from '@/utils/cn'
import Image from 'next/image'
import { HTMLAttributes, useEffect, useState } from 'react'
import { toast } from 'sonner'
import { useSendConfirmEmail } from '../../hooks/use-send-confirm-email'

export interface ConfirmEmailSendCompleteProps
  extends HTMLAttributes<HTMLDivElement> {
  email: string
}

export const ConfirmEmailSendComplete = ({
  className,
  email,
  ...props
}: ConfirmEmailSendCompleteProps) => {
  const { mutate } = useSendConfirmEmail()
  const domain = useFullDomainUrl()
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsButtonDisabled(false)
    }, 5000) // 5초 후 버튼 활성화

    return () => clearTimeout(timer) // 컴포넌트가 언마운트되면 타이머 정리
  }, [])

  const handleResendEmail = () => {
    mutate(
      {
        email,
        returnUrl: domain,
      },
      {
        onSuccess: () => {
          toast.success('인증 메일을 재발송했어요.')
          setIsButtonDisabled(true) // 재발송 후 버튼 다시 비활성화
          setTimeout(() => {
            setIsButtonDisabled(false)
          }, 5000) // 5초 후 버튼 다시 활성화
        },
      },
    )
  }

  return (
    <div
      className={cn(
        'flex min-h-[350px] flex-col items-center justify-center gap-8',
        className,
      )}
      {...props}
    >
      <Image
        src={'/icons/이메일인증모달_완료.svg'}
        alt="이메일인증모달_완료"
        width={88}
        height={88}
      />
      <div className="text-center">
        <h2 className="text-primary">{email}</h2>
        <h2 className="font-semibold">인증 메일을 발송했어요</h2>
      </div>
      <div className="text-center text-caption-01-medium text-gray-5">
        <p>메일함에서 인증을 완료해주세요.</p>
        <p>메일이 오지 않는다면 스팸메일함을 확인해주세요.</p>
      </div>
      <div>
        <Button
          onClick={handleResendEmail}
          className="!text-xs text-gray-5 underline"
          variant="link"
          disabled={isButtonDisabled} // 버튼 비활성화 상태 적용
        >
          메일을 받지 못했어요
        </Button>
      </div>
    </div>
  )
}
